import _ from 'lodash';
import { I18n } from 'common/i18n';
import React from 'react';
import { ForgeDialog, ForgeIcon, ForgeIconButton, ForgeScaffold, ForgeToolbar } from '@tylertech/forge-react';

const t = (k: string, options: { [key: string]: any } = {}) =>
  I18n.t(k, { scope: 'dataset_landing_page', ...options });

const renderPrivateNotice = (view: any, onDismiss: () => void) => {
  if (view.isPrivate) {
    return (
      <section>
        <div className="alert info">
          <span dangerouslySetInnerHTML={{ __html: t('share.visibility_alert_html') }} />
        </div>
      </section>
    );
  } else {
    return null;
  }
};

const onClickOption = (event: any, onClickShareOption: (e: any) => void) => {
  onClickShareOption(event.currentTarget.dataset.shareOption);
};

interface ShareModalProps {
  view: any;
  onDismiss: () => void;
  onClickShareOption: (e: any) => void;
}

const ShareModal = ({ view, onDismiss, onClickShareOption }: ShareModalProps) => {
  return (
    <ForgeDialog
      open={true}
      on-forge-dialog-close={onDismiss}
      aria-labelledby="share-dialog-title"
      aria-describedby="share-dialog-description"
    >
      <div id="share-dialog" data-testid="share-dialog">
        <ForgeScaffold>
          <div slot="header" className="share-dialog-header">
            <ForgeToolbar>
              <h1 slot="start" id="share-dialog-title" className="forge-typography--heading4">
                {t('share.asset')}
              </h1>
              <ForgeIconButton slot="end" className="tyler-icons" onClick={onDismiss}>
                <ForgeIcon name="close" />
              </ForgeIconButton>
            </ForgeToolbar>
          </div>
          <div slot="body" className="share-dialog-container">
            <div id="share-dialog-description">{t('share.description', { dataset_title: view.name })}</div>
            {renderPrivateNotice(view, onDismiss)}

            <div className="section">
              <div className="facebook">
                <a
                  href={view.facebookShareUrl}
                  data-share-option="Facebook"
                  target="_blank"
                  data-testid="share-on-facebook-link"
                  onClick={(e) => onClickOption(e, onClickShareOption)}
                >
                  <span className="icon-facebook" />
                  {t('share.facebook')}
                </a>
              </div>

              <div className="twitter">
                <a
                  href={view.twitterShareUrl}
                  data-share-option="Twitter"
                  target="_blank"
                  data-testid="share-on-twitter-link"
                  onClick={(e) => onClickOption(e, onClickShareOption)}
                >
                  <span className="icon-twitter" />
                  {t('share.twitter')}
                </a>
              </div>

              <div className="email">
                <a
                  href={view.emailShareUrl}
                  data-share-option="Email"
                  data-testid="share-via-email-link"
                  onClick={(e) => onClickOption(e, onClickShareOption)}
                >
                  <span className="icon-email" />
                  {t('share.email')}
                </a>
              </div>
            </div>
          </div>
        </ForgeScaffold>
      </div>
    </ForgeDialog>
  );
};

export default ShareModal;
